import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full flex-col gap-5',
    top: '',
    title: 'heading-xl mb-2',
    text: 'heading-xs',
    input: 'relative h-20 cursor-pointer',
    image: 'size-20 object-cover',
    placeholder: 'bg-blue-light flex-center h-20',
    note: 'heading-xs text-[#595959]',
    link: 'underline underline-offset-4',
    preview: 'relative inline-block',
    remove: 'absolute top-1 right-1 cursor-pointer rounded-full bg-white p-2',
    error: 'text-label-red heading-xs',
    multiplePreview: '[--slide-size:auto] [--slide-spacing:12px]',
    multiplePreviewItem: 'relative inline-block'
  }
});
